module.exports = __webpack_public_path__ + "static/media/trancamento.580ec11e.png";